import styled, { keyframes } from "styled-components";

const rotate = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

export const Container = styled.div`
  display: block;

  svg {
    width: 100%;
    height: 100%;
    display: block;
    transform-origin: center;
    animation: ${rotate} 0.6s linear infinite;
  }
`;
